import { Accordion } from "radix-ui";

const items = [
  {
    q: "Where do the jobs come from?",
    a: "Straight from company career pages on Greenhouse, Lever, Ashby, Workable, Recruitee, BambooHR, JazzHR, Workday and SmartRecruiters. Roles that close drop out of your feed.",
  },
  {
    q: "Does it really apply for me?",
    a: "Yes. Apply and Headcount fills in and submits the application. Your Applications tab shows what went out.",
  },
  {
    q: "What’s a Sankey?",
    a: "A chart of where every application went: sent, rejected, interviews, offers. Mark replies as they come in, then share it in one tap.",
  },
  {
    q: "What if an application fails?",
    a: "It doesn’t count toward your plan.",
  },
  {
    q: "What about Workday?",
    a: "Workday and SmartRecruiters roles open on the company site so you can finish there. They still count in your feed and your Sankey.",
  },
  {
    q: "Can I cancel?",
    a: "Yes, anytime. Your plan runs to the end of the month, then you move to Free.",
  },
];

export function Faq() {
  return (
    <Accordion.Root type="single" collapsible className="divide-y divide-line border-y border-line">
      {items.map((item) => (
        <Accordion.Item key={item.q} value={item.q}>
          <Accordion.Header>
            <Accordion.Trigger className="group flex min-h-18 w-full items-center justify-between gap-6 py-5 text-left font-display text-[19px] font-bold tracking-[-0.02em] text-ink transition-[color] duration-150 hover:text-primary-ink md:text-[21px]">
              {item.q}
              <span
                aria-hidden
                className="relative grid size-9 shrink-0 place-items-center rounded-control bg-sunk transition-[background-color,color,rotate] duration-300 ease-spring group-hover:bg-primary-soft group-data-[state=open]:rotate-180 group-data-[state=open]:bg-primary group-data-[state=open]:text-on-primary"
              >
                <span className="absolute h-[1.5px] w-3 rounded-full bg-current" />
                <span className="absolute h-3 w-[1.5px] rounded-full bg-current transition-[rotate,opacity] duration-200 ease-out group-data-[state=open]:rotate-90 group-data-[state=open]:opacity-0" />
              </span>
            </Accordion.Trigger>
          </Accordion.Header>
          <Accordion.Content className="overflow-hidden data-[state=closed]:animate-accordion-up data-[state=open]:animate-accordion-down">
            <p className="max-w-[60ch] pb-6 pr-12 text-[16px] leading-relaxed text-ink-soft">{item.a}</p>
          </Accordion.Content>
        </Accordion.Item>
      ))}
    </Accordion.Root>
  );
}
